import { render, staticRenderFns } from "./modelThree.vue?vue&type=template&id=080be0ff&scoped=true&"
import script from "./modelThree.vue?vue&type=script&lang=js&"
export * from "./modelThree.vue?vue&type=script&lang=js&"
import style0 from "./modelThree.vue?vue&type=style&index=0&id=080be0ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080be0ff",
  null
  
)

export default component.exports